module.exports = __webpack_public_path__ + "assets/images/vernaculo_150f616ba9058514cd43da98686e23f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dialog-ballons/profiles/vernaculo.png
// module id = 140
// module chunks = 0